import styled from '@emotion/styled'
import { Button } from 'antd'

export const BackButton = styled(Button)`
  color: #4a4a68;
  border: 1px solid #4a4a68;

  &:hover {
    color: #4a4a68;
    border: 1px solid #4a4a68;
  }
`

export const TableHeaderTooltip = styled.div`
  display: flex;
  align-items: center;
  whitespace: nowrap;
`

export const TableCellNoWrap = styled.span`
  white-space: nowrap;
`
